import { useMutation, type UseMutationOptions } from '@tanstack/react-query';
import { submitMfaResend } from '@/services/login.service';
import type { MfaResendResponse } from '@/services/login.types';

type MutationCallbacks = Pick<
  UseMutationOptions<MfaResendResponse, unknown, void>,
  'onSuccess' | 'onError'
>;

interface UseMFAResendMutationArgs extends MutationCallbacks {
  mfaCode: string;
}

const useMFAResendMutation = ({
  mfaCode,
  onSuccess,
  onError,
}: UseMFAResendMutationArgs) =>
  useMutation<MfaResendResponse, unknown, void>({
    mutationFn: () => submitMfaResend({ mfaCode }),
    onSuccess,
    onError,
  });

export default useMFAResendMutation;
